export default __webpack_public_path__ + "static/media/our-story.8160dd92.jpg";